import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, withKeys as _withKeys } from "vue"

const _hoisted_1 = ["tabindex"]
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]


export default /*@__PURE__*/_defineComponent({
  __name: 'ButtonBase',
  props: {
  buttonText: { type: String, default: '' },
  disabled: { type: Boolean, default: false },
  iconLeft: { type: String, default: '' },
  iconRight: { type: String, default: '' },
  size: { type: String, default: 'medium' },
  whiteContent: { type: Boolean, default: false },
  tabIndex: { type: Number, default: 0 }
},
  emits: ['onClicked'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit
function onClicked(event?: Event, preventDefault?: boolean) {
  if (event && preventDefault) event.preventDefault() // Prevent space bar scrolling
  if (!props.disabled) emit('onClicked', event)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["button-base", {
      'button-base__disabled': __props.disabled,
      'button-base__large': __props.size === 'large',
      'button-base__medium': __props.size === 'medium',
      'button-base__medium-icon': __props.size === 'medium-icon',
      'button-base__small': __props.size === 'small',
      'button-base__small-icon': __props.size === 'small-icon',
      'button-base__extra-small': __props.size === 'extra-small',
      'button-base__extra-small-icon': __props.size === 'extra-small-icon',
      'button-base__fill': __props.size === 'fill'
    }]),
    role: "button",
    tabindex: __props.disabled ? -1 : __props.tabIndex,
    onClick: onClicked,
    onKeydown: [
      _withKeys(onClicked, ["enter"]),
      _cache[0] || (_cache[0] = _withKeys((event) => onClicked(event, true), ["space"]))
    ]
  }, [
    (__props.iconLeft.length)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          alt: "Left icon",
          class: _normalizeClass({ 'button-base__white-content': __props.whiteContent }),
          src: __props.iconLeft
        }, null, 10, _hoisted_2))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "left"),
    (__props.buttonText.length)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(['text', { 'text__white-content': __props.whiteContent }])
        }, _toDisplayString(__props.buttonText), 3))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "right"),
    (__props.iconRight.length)
      ? (_openBlock(), _createElementBlock("img", {
          key: 2,
          alt: "Right icon",
          class: _normalizeClass({ 'button-base__white-content': __props.whiteContent }),
          src: __props.iconRight
        }, null, 10, _hoisted_3))
      : _createCommentVNode("", true)
  ], 42, _hoisted_1))
}
}

})